import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <nav className="bg-white py-6 sticky top-0 z-50 border-b border-black/5 backdrop-blur-sm bg-white/80" data-id="element-119">
      <div className="container-custom flex justify-between items-center" data-id="element-120">
        <div className="flex items-center" data-id="element-121">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5cs2ZPr2zzBNwQq8qpJfb2/Messages_Improved_Teal.png" alt="Messages Improved Consulting Logo" className="h-10 mr-3" data-id="element-122" />
          <div className="flex items-center" data-id="element-123">
            <span className="font-orbitron tracking-[0.1em] font-light text-xl text-zinc-800" data-id="element-124">
              Messages Improved
            </span>
            <span className="font-orbitron tracking-[0.1em] font-light text-xl text-teal-dark ml-2" data-id="element-125">
              CONSULTING
            </span>
          </div>
        </div>
        <div className="hidden md:flex space-x-8 items-center" data-id="element-126">
          <a href="#services" className="text-sm hover:text-teal-dark transition-colors" data-id="element-127">
            Services
          </a>
          <a href="#why-different" className="text-sm hover:text-teal-dark transition-colors" data-id="element-128">
            Why Us
          </a>
          <a href="#case-studies" className="text-sm hover:text-teal-dark transition-colors" data-id="element-129">
            Case Studies
          </a>
          <a href="#client-profile" className="text-sm hover:text-teal-dark transition-colors" data-id="element-130">
            Who We Serve
          </a>
          <a href="http://calendly.com/es-lee" target="_blank" rel="noopener noreferrer" className="bg-black text-white px-6 py-2 rounded-sm hover:bg-black/80 transition-colors text-sm" data-id="element-131">
            Book a Consultation
          </a>
        </div>
        <button className="md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-132">
          {isMenuOpen ? <XIcon size={24} data-id="element-133" /> : <MenuIcon size={24} data-id="element-134" />}
        </button>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-black/5 py-4" data-id="element-135">
          <div className="container-custom flex flex-col space-y-4" data-id="element-136">
            <a href="#services" className="text-sm hover:text-teal-dark transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-137">
              Services
            </a>
            <a href="#why-different" className="text-sm hover:text-teal-dark transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-138">
              Why Us
            </a>
            <a href="#case-studies" className="text-sm hover:text-teal-dark transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-139">
              Case Studies
            </a>
            <a href="#client-profile" className="text-sm hover:text-teal-dark transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-140">
              Who We Serve
            </a>
            <a href="http://calendly.com/es-lee" target="_blank" rel="noopener noreferrer" className="bg-black text-white px-6 py-2 rounded-sm hover:bg-black/80 transition-colors text-sm inline-block w-fit" onClick={() => setIsMenuOpen(false)} data-id="element-141">
              Book a Consultation
            </a>
          </div>
        </div>}
    </nav>;
};